import { Helmet } from 'react-helmet';
import { motion } from 'framer-motion';

const EnviosDevoluciones = () => {
  return (
    <>
      <Helmet>
        <title>Envíos y Devoluciones | Jarad</title>
        <meta name="description" content="Política de envíos y devoluciones de Jarad. Información sobre plazos de entrega, gastos de envío y proceso de devolución." />
      </Helmet>

      <div style={{backgroundColor: '#f2ede4'}} className="min-h-screen">
        {/* Hero Section */}
        <div className="py-24 bg-white">
          <div className="content-container">
            <motion.div 
              className="text-center"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
            >
              <h1 className="text-4xl md:text-6xl font-extrabold mb-6 tracking-tight" style={{color: '#0d0d0d'}}>
                Envíos y Devoluciones
              </h1>
              <p className="text-xl md:text-2xl font-light max-w-3xl mx-auto text-gray-600">
                Información sobre nuestros plazos de entrega, gastos de envío y política de devoluciones
              </p>
            </motion.div>
          </div>
        </div>

        {/* Main Content */}
        <div className="py-16">
          <div className="content-container">
            <motion.div 
              className="bg-white shadow-md rounded-2xl p-8 max-w-4xl mx-auto"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
            >
              <div className="prose prose-lg max-w-none">
                <p className="text-gray-500 text-sm mb-8">
                  Última actualización: {new Date().toLocaleDateString('es-ES')}
                </p>
                
                {/* Summary Box */}
                <div className="p-6 rounded-2xl mb-8" style={{backgroundColor: '#f6cf02'}}>
                  <h2 className="text-xl font-bold mb-4" style={{color: '#0d0d0d'}}>
                    Resumen de Envíos y Devoluciones
                  </h2>
                  <ul className="list-disc list-inside space-y-2" style={{color: '#0d0d0d'}}>
                    <li>Envío gratuito en pedidos superiores a 50€</li>
                    <li>Entrega en 2-3 días laborables en península</li>
                    <li>Derecho de devolución en 14 días</li>
                    <li>Seguimiento de pedido incluido</li>
                  </ul>
                </div>
                
                <h2 className="text-2xl font-bold mt-8 mb-4" style={{color: '#0d0d0d'}}>
                  Política de Envíos
                </h2>
                <p className="text-gray-700 mb-6">
                  En Jarad nos comprometemos a entregar tus productos de nutrición para mascotas de forma rápida y segura. 
                  Trabajamos con las mejores empresas de transporte para garantizar que tu pedido llegue en perfectas condiciones.
                </p>
                
                <h3 className="text-xl font-bold mt-6 mb-3" style={{color: '#0d0d0d'}}>
                  Plazos de Entrega
                </h3>
                <p className="text-gray-700 mb-4">
                  Los plazos de entrega varían según la zona de destino y el tipo de envío seleccionado:
                </p>
                
                <div className="overflow-x-auto my-6">
                  <table className="min-w-full border-2 border-gray-200 text-sm rounded-2xl overflow-hidden">
                    <thead style={{backgroundColor: '#8ed1fc'}}>
                      <tr>
                        <th className="py-3 px-4 text-left font-bold" style={{color: '#0d0d0d'}}>
                          Zona
                        </th>
                        <th className="py-3 px-4 text-left font-bold" style={{color: '#0d0d0d'}}>
                          Envío Estándar
                        </th>
                        <th className="py-3 px-4 text-left font-bold" style={{color: '#0d0d0d'}}>
                          Envío Express
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-white">
                      <tr className="border-b border-gray-200">
                        <td className="py-3 px-4 text-gray-700">Península</td>
                        <td className="py-3 px-4 text-gray-700">2-3 días laborables</td>
                        <td className="py-3 px-4 text-gray-700">24-48h</td>
                      </tr>
                      <tr className="border-b border-gray-200">
                        <td className="py-3 px-4 text-gray-700">Islas Baleares</td>
                        <td className="py-3 px-4 text-gray-700">3-5 días laborables</td>
                        <td className="py-3 px-4 text-gray-700">2-3 días laborables</td>
                      </tr>
                      <tr className="border-b border-gray-200">
                        <td className="py-3 px-4 text-gray-700">Islas Canarias</td>
                        <td className="py-3 px-4 text-gray-700">5-7 días laborables</td>
                        <td className="py-3 px-4 text-gray-700">3-4 días laborables</td>
                      </tr>
                      <tr>
                        <td className="py-3 px-4 text-gray-700">Europa</td>
                        <td className="py-3 px-4 text-gray-700">5-7 días laborables</td>
                        <td className="py-3 px-4 text-gray-700">3-4 días laborables</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                
                <h3 className="text-xl font-bold mt-6 mb-3" style={{color: '#0d0d0d'}}>
                  Gastos de Envío
                </h3>
                <p className="text-gray-700 mb-4">
                  Los gastos de envío se calculan automáticamente según el peso, volumen y destino del pedido. 
                  Puedes consultar el coste exacto antes de finalizar tu compra.
                </p>
                
                <div className="p-4 rounded-2xl mb-6" style={{backgroundColor: '#e8b4a0'}}>
                  <h4 className="font-bold mb-2" style={{color: '#0d0d0d'}}>
                    🚚 Envío Gratuito
                  </h4>
                  <p style={{color: '#0d0d0d'}}>
                    Disfruta de envío gratuito en todos los pedidos superiores a 50€ en península. 
                    Para otros destinos, consulta las condiciones específicas.
                  </p>
                </div>
                
                <h2 className="text-2xl font-bold mt-8 mb-4" style={{color: '#0d0d0d'}}>
                  Seguimiento del Pedido
                </h2>
                <p className="text-gray-700 mb-6">
                  Una vez procesado tu pedido, recibirás un email con el número de seguimiento para que puedas 
                  consultar el estado de tu envío en tiempo real a través de la web de la empresa de transporte.
                </p>
                
                <h2 className="text-2xl font-bold mt-8 mb-4" style={{color: '#0d0d0d'}}>
                  Política de Devoluciones
                </h2>
                <p className="text-gray-700 mb-6">
                  En Jarad queremos que estés completamente satisfecho con tu compra. Si por cualquier motivo 
                  no estás conforme con tu pedido, puedes devolverlo siguiendo nuestro sencillo proceso.
                </p>
                
                <h3 className="text-xl font-bold mt-6 mb-3" style={{color: '#0d0d0d'}}>
                  Plazo de Devolución
                </h3>
                <p className="text-gray-700 mb-4">
                  Tienes 14 días naturales desde la recepción del pedido para solicitar la devolución, 
                  de acuerdo con la legislación vigente sobre protección de consumidores.
                </p>
                
                <h3 className="text-xl font-bold mt-6 mb-3" style={{color: '#0d0d0d'}}>
                  Proceso de Devolución
                </h3>
                <div className="space-y-3 mb-6">
                  <div className="flex items-start space-x-3">
                    <div className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0" style={{backgroundColor: '#f6cf02'}}>
                      <span className="text-sm font-bold" style={{color: '#0d0d0d'}}>1</span>
                    </div>
                    <p className="text-gray-700">Contacta con nuestro servicio de atención al cliente</p>
                  </div>
                  <div className="flex items-start space-x-3">
                    <div className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0" style={{backgroundColor: '#8ed1fc'}}>
                      <span className="text-sm font-bold" style={{color: '#0d0d0d'}}>2</span>
                    </div>
                    <p className="text-gray-700">Recibe las instrucciones y etiqueta de devolución</p>
                  </div>
                  <div className="flex items-start space-x-3">
                    <div className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0" style={{backgroundColor: '#e8b4a0'}}>
                      <span className="text-sm font-bold" style={{color: '#0d0d0d'}}>3</span>
                    </div>
                    <p className="text-gray-700">Empaqueta el producto en su embalaje original</p>
                  </div>
                  <div className="flex items-start space-x-3">
                    <div className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0" style={{backgroundColor: '#c7c7c7'}}>
                      <span className="text-sm font-bold" style={{color: '#0d0d0d'}}>4</span>
                    </div>
                    <p className="text-gray-700">Envía el paquete y recibe tu reembolso</p>
                  </div>
                </div>
                
                <h3 className="text-xl font-bold mt-6 mb-3" style={{color: '#0d0d0d'}}>
                  Condiciones de Devolución
                </h3>
                <ul className="list-disc list-inside space-y-2 text-gray-700 mb-6">
                  <li>Los productos deben estar en su embalaje original</li>
                  <li>No deben haber sido abiertos ni utilizados</li>
                  <li>Deben conservar todas las etiquetas y documentación</li>
                  <li>Los productos perecederos no admiten devolución por motivos de seguridad alimentaria</li>
                </ul>
                
                <h3 className="text-xl font-bold mt-6 mb-3" style={{color: '#0d0d0d'}}>
                  Reembolsos
                </h3>
                <p className="text-gray-700 mb-6">
                  Una vez recibida y verificada la devolución, procederemos al reembolso del importe del producto 
                  en un plazo máximo de 14 días laborables, utilizando el mismo método de pago empleado en la compra original.
                </p>
                
                <h2 className="text-2xl font-bold mt-8 mb-4" style={{color: '#0d0d0d'}}>
                  Productos Dañados o Defectuosos
                </h2>
                <p className="text-gray-700 mb-6">
                  Si recibes un producto dañado o defectuoso, contacta inmediatamente con nuestro servicio de atención al cliente. 
                  Nos haremos cargo de todos los gastos de devolución y te enviaremos un producto de reemplazo sin coste adicional.
                </p>
                
                <div className="p-6 rounded-2xl mt-8" style={{backgroundColor: '#f6cf02'}}>
                  <h2 className="text-xl font-bold mb-4" style={{color: '#0d0d0d'}}>
                    ¿Necesitas Ayuda?
                  </h2>
                  <p className="mb-4" style={{color: '#0d0d0d'}}>
                    Si tienes alguna duda sobre envíos o devoluciones, no dudes en contactarnos:
                  </p>
                  <div className="space-y-2" style={{color: '#0d0d0d'}}>
                    <p><strong>Email:</strong> info@semillasjarad.es</p>
                    <p><strong>Teléfono:</strong> +34 955 83 68 23</p>
                    <p><strong>Horario:</strong> Lun-Vie 9:00-18:00, Sáb 10:00-15:00</p>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EnviosDevoluciones;